import { Component, inject } from '@angular/core';
import { SEMANTIC_STYLES } from 'src/ui/types/semantic.type';
import { ToastAction, ToastType } from 'src/ui/types/toast.type';
import { ToastService } from 'src/utils/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  templateUrl: './toast.component.html',
})
export class ToastComponent {
  protected readonly toastService = inject(ToastService);

  protected style(type: ToastType) {
    return SEMANTIC_STYLES[type];
  }

  protected positionClass(position: 'left' | 'right'): string {
    return position === 'left' ? 'xs:justify-start' : 'xs:justify-end';
  }

  remove(id: number): void {
    this.toastService.remove(id);
  }

  runAction(id: number, action: ToastAction): void {
    this.toastService.remove(id);
    action.handler();
  }
}
